import { View } from '../../core/types';
import { BaseTool } from '../BaseTool';
import { v4 as uuidv4 } from 'uuid';

export class ThreeDViewTool extends BaseTool {
    id = 'VIEW_3D';
    name = 'Default 3D View';
    cursor = 'default';

    onActivate(): void {
        this.createDefault3DView();
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    private createDefault3DView() {
        if (!this.context) return;

        const viewId = uuidv4();

        // Find if {3D} exists
        // simplified...

        const newView: View = {
            id: viewId,
            name: '{3D}',
            type: '3D',
            discipline: 'Coordination',
            scale: 100,
            detailLevel: 'Fine',
            visibility: {},
            filters: [],
            camera: {
                position: [10, 10, 10],
                target: [0, 0, 0],
                projection: 'Perspective'
            }
        };

        this.context.bimStore.addView(newView);
        this.context.bimStore.setActiveView(viewId);
        console.log('Created and switched to default 3D view.');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
